import React from 'react'
import { useQuery } from '@apollo/client'
import { Tabs, Tab } from '../Tabs/index'
import Expandable from '../Expandable/index'
import { GET_FAQS } from '../../services/content/query'

const FaqsList = (props) => {
  const {
    pmSection,
    language,
    sectionId,
    titleGroupIds = [],
  } = props

  const hasValidIds = Array.isArray(titleGroupIds) && titleGroupIds.length > 0
  const { data, loading } = useQuery(GET_FAQS, {
    variables: {
      titleGroupIds,
      language: language ? [language, '_primary'] : ['en', '_primary'],
    },
    skip: !hasValidIds,
  })

  const faqs = data?.contentList?.content || []
  const sectionData = sectionId && pmSection ? pmSection.getIn([sectionId, 'data', 'data']) : null
  const headerLabel = sectionData?.getIn(['header', 'label'], '') || ''

  if (!hasValidIds) return null
  if (loading) return null

  return (
    <div className="faqs-container">
      <Tabs>
        <Tab label={headerLabel}>
          {
            faqs.map((faq) => (
              <Expandable
                key={faq.id}
                header={faq.title}
              >
                <React.Fragment>
                  {faq.shortDescription || faq.description || ''}
                </React.Fragment>
              </Expandable>
            ))
          }
        </Tab>
      </Tabs>
    </div>
  )
}

export default FaqsList
